/// <reference path="../types.d.ts" />
import { createReducer } from '@reduxjs/toolkit';
import InitialState from '../reducers/initial-state';
import * as UIActions from '../actions/ui';
import { jumpContext } from '../actions/contexts.action';
import * as MyStatusActions from '../actions/my-status';
import { LOAD_STATES } from './common';
const reducer = createReducer(InitialState.myStatus, (builder)=>{
    // Default cases from cmxReducerFactory: reset state on logout or context jump
    builder.addCase(UIActions.logout.type, ()=>({
            ...InitialState.myStatus
        }));
    builder.addCase(jumpContext.pending.type, ()=>({
            ...InitialState.myStatus
        }));
    builder.addCase(MyStatusActions.toggleIsOpenMyStatus, (state, action)=>({
            ...state,
            myStatusIsOpen: action.payload
        }));
    builder.addCase(MyStatusActions.updateStatus.pending, (state, action)=>({
            ...state,
            newStatus: action.meta.arg
        }));
    builder.addCase(MyStatusActions.updateStatus.rejected, (state, action)=>({
            ...state,
            newStatus: action.meta.arg
        }));
    builder.addCase(MyStatusActions.updateStatus.fulfilled, (state, action)=>({
            ...state,
            newStatus: action.payload
        }));
    builder.addCase(MyStatusActions.listStatus.pending, (state)=>({
            ...state,
            loadState: LOAD_STATES.started
        }));
    builder.addCase(MyStatusActions.listStatus.rejected, (state)=>({
            ...state,
            loadState: LOAD_STATES.failed
        }));
    builder.addCase(MyStatusActions.listStatus.fulfilled, (state, action)=>({
            ...state,
            statusList: action.payload,
            loadState: LOAD_STATES.done
        }));
});
export default reducer;
